<script>
import skillUpWallet from '../../services/skillUp/wallet'
export default {
  components: {},
  data() {
    return {
      walletAmount: [],
    }
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => {
        return []
      },
    },
    headerClass: {
      type: String,
      default: '',
    },
  },
  methods: {
    async allBallanceInformation() {
      try {
        const result = await skillUpWallet.getAllBalanceInformation()
        this.walletAmount = result.data.data
      } catch (error) {
        console.log(error)
      }
    },
  },
  mounted() {
    if (this.$route.path === '/list/allbalancewithuserinfo') this.allBallanceInformation()
  },
}
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="col-12">
      <div class="page-title-box d-flex align-items-center justify-content-between" :class="headerClass">
        <h4 class="mb-0 font-size-18">{{ title }}</h4>

        <div class="page-title-right">
          <b-breadcrumb :items="items" class="m-0"></b-breadcrumb>
        </div>
      </div>
    </div>

    <div
      v-if="$route.path.includes('allbalancewithuserinfo') && !$route.path.includes('/detail') && !$route.path.includes('/add') && !$route.path.includes('transactionDetail')"
      class="my-3"
    >
      <div class="d-flex gap-3 align-items-center flex-wrap">
        <div class="table_header_box">
          <div class="d-flex gap-2">
            <p style="color: rgba(73, 80, 87, 1); font-size: 12px; margin: 0">موجودی کل کیف پول های کاربران ( تومان )</p>

            <p style="color: rgba(52, 195, 143, 1); font-size: 15px; margin: 0">{{ walletAmount.sumAllBalances.toLocaleString() }}</p>
          </div>
        </div>

        <div class="table_header_box">
          <div class="d-flex gap-2">
            <p style="color: rgba(73, 80, 87, 1); font-size: 12px; margin: 0">موجودی کل کیف پول تومانی کاربران</p>

            <p style="color: rgba(52, 195, 143, 1); font-size: 15px; margin: 0">{{ walletAmount.allBalances[1].total.toLocaleString() }}</p>
          </div>
        </div>

        <div class="table_header_box">
          <div class="d-flex gap-2">
            <p style="color: rgba(73, 80, 87, 1); font-size: 12px; margin: 0">موجودی کل کیف پول اسکیل کوین کاربران</p>

            <p style="color: rgba(52, 195, 143, 1); font-size: 15px; margin: 0">{{ walletAmount.allBalances[0].total.toLocaleString() }}</p>
          </div>
        </div>

        <div class="table_header_box">
          <div class="d-flex gap-2">
            <p style="color: rgba(73, 80, 87, 1); font-size: 12px; margin: 0">موجودی کل کیف پول اسکیل کوین من</p>

            <p style="color: rgba(29, 63, 168, 1); font-size: 15px; margin: 0">
              {{ walletAmount.myBalances.length ? walletAmount.myBalances.find((c) => c.coin === 'اسکیل کوین').total.toLocaleString() : 0 }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>

<style lang="scss" scoped>
.table_header_box {
  border-radius: 5px;
  box-shadow: 2px 2px rgba(151, 151, 151, 0.18);
  padding: 8px 16px;
  background: rgba(255, 255, 255, 1);
}
</style>
